import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import { invalidateOrganizationList } from '@/session/organizationList';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';

export type InviteAcceptanceData = {
  code: string;
  first_name: string;
  last_name: string;
  password: string;
  password_verify: string;
};

export type InviteAcceptanceResponse = {
  success: boolean;
  message?: string;
};

type RequestParams = {
  data: InviteAcceptanceData;
};

export const acceptInvite = async ({ data }: RequestParams): Promise<EndpointResponse<InviteAcceptanceResponse>> => {
  try {
    const response = await scopedApi(GLOBAL_SCOPE).post<EndpointResponse<InviteAcceptanceResponse>>('/organization/invite_accept', data, {
      authPolicy: 'anonymous',
    });
    if (!response.data.isError) invalidateOrganizationList();
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e, { redactRequestData: true });
  }
};
